export default{
  "common.mode.auto": "Autoconsommation",
  "common.mode.economy": "Mode économique",
  "common.mode.exigency": "Mode d'urgence",

  "common.grid": "Réseau électrique",
  "common.evChargers": "Bornes de recharge",
  "common.evCharger": "Borne de recharge",
  "common.pv": "Photovoltaïque",
  "common.inverter": "Onduleur",
  "common.pcs": "Onduleur+Batterie",
  "common.terminal": "Équipement terminal",
  "common.airc": "Climatiseur",
  "common.engine": "Générateur",
  "common.battery": "Batterie",
  "common.metter": "Compteur électrique",
  "common.other": "Autre",
  "common.power": "Puissance",
  "common.powerTotal": "Puissance totale",
  "common.voltage": "Tension",
  "common.electricity": "Électricité",
  "common.current": "Courant",
  "common.homeUsage": "Charge totale domestique",
  "common.battery.power": "Puissance batterie",

  "common.noDataAvailable": "Aucune donnée disponible~",
  "common.tips": "Conseil",
  "common.reset": "Réinitialiser",
  "common.currencyUnit": "€",
  "common.submiting": "Soumission en cours, veuillez patienter...",
  "common.close": "Fermer",
  "common.from": "De",
  "common.useIn": "Utilisé pour",
  "common.energyPercent": "Pourcentage du flux énergétique",
  "common.dataFlow": "Flux de données",
  "common.getDataIng": "Récupération des données, veuillez patienter...",
  "common.pageLoading": "Chargement du contenu, veuillez patienter...",
  "common.reseting": "Réinitialisation du contenu, veuillez patienter...",
  "common.save": "Sauvegarder",
  "common.onlyNumberTips": "Seuls les chiffres sont autorisés",
  "common.offline": "Hors ligne",
  "common.online": "En ligne",
  "common.fault": "Défaut",
  "common.charge": "Charge",
  "common.discharge": "Décharge",
  "common.buy": "Achat",
  "common.sell": "Vente",
  "common.loadingInfo": "Chargement, veuillez patienter...",

  "common.moreFeatures": "Plus de fonctionnalités",
  "common.confirm": "Confirmer",
  "common.saveing": "Sauvegarde en cours, veuillez patienter...",
  "common.searchPlacholder": "Veuillez saisir un mot-clé",
  "common.iSee": "J'ai compris",
  "common.pageErrorTips1": "Oups, erreur de page~",
  "common.pageErrorTips2": "Veuillez actualiser ou contacter le support~",
  "common.refresh": "Actualiser",
  "common.backToHome": "Retour à l'accueil",
  "common.checkTips": "Vérification en cours, veuillez patienter...",
  "common.back": "Retour",
  "common.cancel": "Annuler",
  "common.optional": "Optionnel",
  "common.required": "Requis",
  "common.status": "Statut",
  "common.statusNoDelete": "Non supprimé",
  "common.statusDelete": "Supprimé",
  "common.submit": "Soumettre",
  "common.disable": "Désactiver",
  "common.enable": "Activer",
  "common.year": "An",
  "common.month": "Mois",
  "common.day": "Jour",
  "common.version": "Version :",
  "common.backHome": " Retour à l'accueil",
  "common.backHomeSorry": " Désolé, la page s'est égarée",
  "common.requestTips1": "Traitement des données, ne pas soumettre à nouveau",
  "common.requestTips2": "Avis système",
  "common.requestTips3": "Session expirée, veuillez vous reconnecter",
  "common.requestTips4": "Se reconnecter",
  "common.requestTips5": "Session invalide ou expirée, veuillez vous reconnecter.",
  "common.requestTips6": "Erreur du serveur, veuillez réessayer plus tard.",
  "common.requestTips7": "Délai d'attente API dépassé",
  "common.requestTips8": "API système",
  "common.requestTips9": "Erreur",
  "common.iknow": "J'ai compris",
  "common.logoutSuccess": "Déconnexion réussie",

  "common.knowMore.title": "Pour en savoir plus, contactez BN Energy",
  "common.knowMore.email": "Email de contact",
  "common.knowMore.phone": "Téléphone de contact",
  "common.knowMore.wechat": "WeChat de contact",
  "common.knowMore.website": "Site officiel",
  "common.knowMore.address": "Adresse de contact",
  "common.knowMore.addressDetail": "Chambre 1205, 1301, Bâtiment 5, No.8 Qinghe Road, Huangjingkeng, Huangjiang Town, Dongguan, Province du Guangdong",

  "common.localConnection": "Connexion locale",
  "common.operateInApp": "Veuillez utiliser l'application!",

  "common.enbleStaus": "Statut d'activation",
  "common.battery.status": "Ni charge ni décharge",

  "account.forgetThePassword": "Mot de passe oublié",
  "account.logInDirectly": "Aller à la connexion",
  "account.tips1": "Redirection, veuillez patienter...",
  "account.tips2": "Veuillez accepter les conditions d'utilisation!",
  "account.autoLogin": "Connexion automatique",
  "account.userLogin": "Connexion utilisateur",
  "account.registerTips": "Pas de compte? Cliquez ici pour vous inscrire",
  "account.userEmail": "Nom d'utilisateur/Email",
  "account.userEmailTips": "Veuillez saisir nom d'utilisateur/email",
  "account.password": "Mot de passe",
  "account.passwordTips": "Veuillez saisir le mot de passe",
  "account.submit": "Soumettre",
  "account.submitTips": "Soumission en cours, veuillez patienter...",
  "account.otherLoginTips": "Ou autre méthode de connexion",
  "account.userRegistration": "Inscription utilisateur",
  "account.userName": "Nom d'utilisateur",
  "account.userNameTips": "Veuillez saisir le nom d'utilisateur",
  "account.emailTips1": "Veuillez saisir l'adresse email",
  "account.emailTips2": "Format d'email incorrect",
  "account.phone": "Numéro de téléphone",
  "account.phoneTips1": "Veuillez saisir le numéro de téléphone",
  "account.phoneTips2": "Numéro de téléphone incorrect",
  "account.phoneTips3": "Veuillez saisir le numéro de téléphone",
  "account.passwordTips1": "Veuillez saisir un mot de passe de 6-30 caractères",
  "account.passwordTips2": "Format incorrect: lettres, chiffres, tirets bas et traits d'union autorisés, 6-12 caractères",
  "account.passwordTips3": "Mots de passe non identiques, veuillez vérifier!",
  "account.passwordTips4": "Veuillez saisir le mot de passe",
  "account.passwordTips5": "Confirmer le mot de passe",
  "account.passwordTips6": "Veuillez confirmer le mot de passe",
  "account.passwordTips7": "Mots de passe non identiques, veuillez vérifier!",
  "account.passwordTips8": "Veuillez confirmer le mot de passe",
  "account.passwordTips9": "Inscription réussie!",
  "account.passwordTips10": "Votre nom d'utilisateur est:",
  "account.emailIs": "Email est:",
  "account.goToLoginPage": "s avant redirection automatique",
  "account.goLogin": "Se connecter",
  "account.goRegister": "S'inscrire",
  "account.loginSuccess": "Connexion réussie",
  "account.email": "Email",
  "account.sologn": "Solutions énergétiques sur mesure",
  "account.pleaseAgree": "J'ai lu et j'accepte",
  "userAgreement.privacyPolicy": "Politique de confidentialité",

  "account.code": "Code de vérification",
  "account.codeTips": "Veuillez saisir le code de vérification",
  "account.codeTips2": "Code de vérification incorrect",

    "account.inviteCodeTips": "Veuillez saisir le code d'invitation",
    "account.inviteCodeHint": "Veuillez contacter l'installateur ou le personnel d'exploitation et de maintenance pour obtenir le code d'invitation",
  "account.modifyPasswordByAccount": "Modifier le mot de passe par compte",
  "account.modifyPasswordByEmail": "Modifier le mot de passe par email",
  "account.getPasswordByAccount": "Récupérer le mot de passe par compte",
  "account.getPasswordByEmail": "Récupérer le mot de passe par email",

  "account.sendEmailTips": "Code envoyé par email, veuillez vérifier",
  "account.name": "Nom du compte",
  "account.newPassword": "Nouveau mot de passe",
  "account.confirmNewPassword": "Confirmer le nouveau mot de passe",
  "account.nameTips": "Veuillez saisir le nom du compte",
  "account.passwordModifySuccess": "Mot de passe modifié avec succès",
  "account.emailCode": "Code de vérification email",
  "account.emailCodeTips": "Veuillez saisir le code de vérification email",
  "account.emailCodeTips2": "Code de vérification email incorrect",
  "account.emailModifySuccess": "Mot de passe modifié avec succès",
  "account.passworTips1": "Votre mot de passe a été réinitialisé!",
  "account.passwordTips11": "Veuillez confirmer le mot de passe",
  "account.passwordTips12": "Veuillez saisir le nouveau mot de passe",
  "account.nickname": "Pseudonyme",
  "account.modifyNickname": "Modifier le pseudonyme",
  "account.modifyNicknameSuccess": "Pseudonyme modifié avec succès!",
  "account.nicknameTips": "Veuillez saisir le pseudonyme",
  "account.nicknameError": "Échec de la modification du pseudonyme!",

  "account.login": "Se connecter",
  "account.quickRegister": "Inscription rapide",
  "account.sendCode": "Envoyer le code",
  "account.sendTips": "s avant nouvel envoi",
  "account.sendEmailIng": "Envoi d'email en cours, veuillez patienter...",
  "account.emailNotEmpty": "L'adresse email ne peut pas être vide",
  "account.registerAccount": "Créer un compte",
  "account.registerWelcome": "Bienvenue sur SusprSafe",
  "account.usernameLimit": "Le nom d'utilisateur doit commencer par une lettre, et ne peut contenir que des lettres, chiffres et underscores, longueur 5-15 caractères",

  "copyright.desc2": "Information de dépôt: YueICP-2021169764",

  "editUserInfo.editUserInformation": "Modifier les informations utilisateur",
  "editUserInfo.modifyUsername": "Modifier le nom d'utilisateur",
  "editUserInfo.changePictures": "Modifier la photo de profil",
  "editUserInfo.savePicturesSuccess": "Photo de profil sauvegardée",
  "editUserInfo.saveError": "Échec de la sauvegarde",
  "editUserInfo.pictureLimit": "Image doit être < 2MB",
  "editUserInfo.uploadPicture": "Télécharger une photo de profil",
  "editUserInfo.picturePreview": "Aperçu",

  "editUserInfo.bindPhoneNumber": "Lier un numéro de téléphone",
  "editUserInfo.bindEmail": "Lier un email",
  "editUserInfo.changePassword": "Modifier le mot de passe",

  "editUserInfo.notificationSettings": "Paramètres de notification",
  "editUserInfo.editAccount": "Modifier les informations du compte",
  "editUserInfo.waitBingting": "Liaison en cours, veuillez patienter...",
  "editUserInfo.collapse": "Réduire",
  "editUserInfo.modifyBinding": "Modifier la liaison",

  "editUserInfo.emailAddress": "Adresse email",
  "editUserInfo.tips1": "Email lié avec succès",
  "editUserInfo.tips2": "Échec de la sauvegarde",
  "editUserInfo.tips3": "Envoi du code de vérification, veuillez patienter...",
  "editUserInfo.tips4": "Code envoyé à xxxx, veuillez vérifier",
  "editUserInfo.tips5": "Échec de l'envoi du code!",
  "editUserInfo.tips6": "Numéro de téléphone déjà lié",
  "editUserInfo.tips7": "Email déjà lié",
  "editUserInfo.emailTips1": "Veuillez saisir l'adresse email",
  "editUserInfo.emailTips2": "Format d'email incorrect",
  "editUserInfo.emailTips3": "xxxxs avant nouvel envoi",
  "editUserInfo.emailTips4": "Obtenir code",
  "editUserInfo.emailTips5": "Le code de vérification email ne peut pas être vide",
  "editUserInfo.emailTips6": "Code de vérification email incorrect",
  "editUserInfo.emailCode": "Code de vérification email",
  "editUserInfo.save": "Sauvegarder",

  "editUserInfo.phoneTips1": "Numéro de téléphone lié avec succès",
  "editUserInfo.phoneTips2": "Envoi du SMS en cours, veuillez patienter...",
  "editUserInfo.phoneTips3": "SMS envoyé à xxxx, veuillez vérifier",
  "editUserInfo.phoneTips4": "Échec de l'envoi du SMS!",
  "editUserInfo.phoneTips5": "Veuillez saisir le numéro de téléphone",
  "editUserInfo.phoneTips6": "Format de numéro incorrect",
  "editUserInfo.phoneTips7": "Envoyer le code SMS",
  "editUserInfo.phoneTips8": "Code SMS",
  "editUserInfo.phoneTips9": "Le code de vérification ne peut pas être vide",
  "editUserInfo.phoneTips10": "Code de vérification incorrect",
  "editUserInfo.phone": "Numéro de téléphone",

  "editUserInfo.noticeTips1": "Échec de la récupération des paramètres de notification!",
  "editUserInfo.noticeTips2": "Paramètres de notification sauvegardés!",
  "editUserInfo.noticeTips3": "Notification batterie faible",
  "editUserInfo.noticeTips4": "Notification fin de charge",
  "editUserInfo.errorNotification": "Notification d'erreur",
  "editUserInfo.updateNotification": "Notification de mise à jour",
  "editUserInfo.monthlyStatisticsNotification": "Notification statistiques mensuelles",
  "editUserInfo.notificationMethod": "Méthode de réception",

  "editUserInfo.userNameTips1": "Nom d'utilisateur sauvegardé",
  "editUserInfo.userNameTips2": "Échec de la sauvegarde du nom d'utilisateur",
  "editUserInfo.userNameTips3": "Veuillez saisir le nom d'utilisateur",
  "editUserInfo.userNameTips4": "Format incorrect: chiffres, underscores, lettres uniquement",
  "editUserInfo.userNameTips5": "Veuillez saisir le nom d'utilisateur",
  "editUserInfo.userNameTips6": "Sauvegarde en cours, veuillez patienter...",
  "editUserInfo.userName": "Nom d'utilisateur",

  "editUserInfo.avatorTips": "Cliquer pour modifier la photo de profil",
  "editUserInfo.verifyCodeTips1": "Veuillez saisir le code reçu:",
  "editUserInfo.verifyCodeTips2": "Pour la sécurité, veuillez envoyer un code à l'ancien numéro:",
  "editUserInfo.verifyCodeTips3": "Obtenir code",
  "editUserInfo.verifyCodeTips4": "Ancien numéro vérifié, veuillez saisir le nouveau",
  "editUserInfo.verifyCodeTips5": "Pour la sécurité, veuillez envoyer un code à l'ancien email:",
  "editUserInfo.verifyCodeTips6": "Ancien email vérifié, veuillez saisir le nouveau",
  "editUserInfo.verifyCodeTips7": "Ancien mot de passe",
  "editUserInfo.verifyCodeTips8": "Veuillez d'abord lier un email!",
  "editUserInfo.verifyCodeTips9": "Code envoyé par email, veuillez vérifier",
  "editUserInfo.verifyCodeTips10": ", redirection automatique vers la page de connexion",

  "hems.notice.title": "Titre de la notification",
  "hems.notice.content": "Contenu de la notification",
  "hems.notice.operate": "Opération",
  "hems.notice.noRead": "Non lu",
  "hems.notice.read": "Lu",
  "hems.notice.warning": "Alerte",
  "hems.notice.error": "Erreur",
  "hems.notice.success": "Statistiques et règlement",
  "hems.notice.sys": "Information système",
  "hems.notice.operateSuccess": "Opération réussie",
  "hems.notice.operateTips": "Veuillez sélectionner les éléments à traiter",

  "hems.home.selfuseRate": "Taux d'autoconsommation",
  "hems.home.percent": "Pourcentage",
  "hems.home.todayData": "Données du jour",
  "hems.home.todayPowerGeneration": "Production du jour",
  "hems.home.salesIncome": "Revenus de vente d'électricité",
  "hems.home.saved": "Économies réalisées",
  "hems.home.reduce": "Réduction d'empreinte carbone",
  "hems.home.tips1": "Aucune donnée, vous n'avez pas lié xxxx",
  "hems.home.criticalLoad": "Charge critique",
  "hems.home.keyVoltage": "Tension critique",
  "hems.home.householdLoad": "Charge domestique",
  "hems.home.householdVoltage": "Tension domestique",
  "hems.home.generalLoad": "Charge générale",
  "hems.home.generalVoltage": "Tension générale",
  "hems.home.batteryHealth": "État de la batterie",
  "hems.home.averageTemp": "Température moyenne",
  "hems.home.gridLoad": "Charge du réseau",
  "hems.home.toggeleDataSource": "Données affichées changées pour:",
  "hems.home.toggleTips": "Confirmer le changement?",
  "hems.home.modeSending": "Envoi de la commande de mode, veuillez patienter...",
  "hems.home.modeSuccess": "Commande de changement de mode envoyée!",
  "hems.home.isOnline": "Statut en ligne",
  "hems.home.useStatus": "Statut d'utilisation",
  "hems.home.workModeText": "Mode de travail actuel:",
  "hems.home.toggleDataSourceText": "Données affichées changées pour:",
  "hems.ev.charge.status": "État de charge",
  "hems.ev.charge.time": "Durée de charge",
  "hems.ev.charge.count": "Quantité de charge en temps réel",
  "hems.ev.charge.status.empty": "Libre",
  "hems.ev.charge.status.ing": "En charge",
  "hems.ev.charge.status.null": "Branché mais pas en charge",
  "hems.ev.charge.status.error": "Défaut",
  "hems.hour": "Heure",
  "hems.minue": "Minute",
  "hems.ev.chagre.number": "Numéro de borne",

  "hems.userGuide.selfUse": "Autoconsommation",
  "hems.userGuide.selfUseTips": "Priorité à l'énergie solaire, complément réseau si besoin",
  "hems.userGuide.economyMode": "Mode économique",
  "hems.userGuide.economyModeTips": "Optimisation basée sur les prix de l'électricité",
  "hems.userGuide.emergencyMode": "Mode d'urgence",
  "hems.userGuide.emergencyModeTips": "Priorité aux charges critiques",

  "hems.history.energyStatistics": "Statistiques énergétiques",
  "hems.history.revenueStatistics": "Statistiques de revenus",
  "hems.history.greenStatistics": "Réduction carbone",
  "hems.history.revenueTitle": "Revenus totaux de vente",
  "hems.history.savingsTitle": "Économies totales",
  "hems.history.carbonTitle": "Réduction carbone totale",
  "hems.history.day": "Jour",
  "hems.history.month": "Mois",
  "hems.history.year": "An",
  "hems.history.beforeDay": "Jour précédent",
  "hems.history.afterDay": "Jour suivant",
  "hems.history.beforeMonth": "Mois précédent",
  "hems.history.afterMonth": "Mois suivant",
  "hems.history.beforeYear": "Année précédente",
  "hems.history.afterYear": "Année suivante",
  "hems.history.totalUse": "Utilisation totale",
  "hems.history.fullScreen": "Plein écran",
  "hems.history.timeSelect": "Sélection de date",
  "sync.tips1": "Commande de synchronisation envoyée!",
  "sync.tips2": "Synchronisation en cours, peut prendre du temps, vérifier dans 30 minutes~",
  "sync.tips3": "Synchronisation possiblement retardée, en cas d'anomalie:",
  "sync.tips4": "Synchroniser les données",

  "charge.info": "Information de borne de recharge",
  "news.loading": "Chargement...",
  "news.noMore": "Plus de contenu",
  "hems.pv.power": "Alimentation solaire",

  "ueh.sellPower": "Électricité vendue",

  "menu.home": "Accueil",
  "menu.history": "Données historiques",
  "menu.device": "Appareils",
  "menu.settings": "Paramètres",
  "menu.messageCenter": "Centre de messages",
  "menu.help": "Aide & Support",
  "menu.mine": "Mon compte",

  "mine.userSetting": "Paramètres utilisateur",
  "mine.terminalSetting": "Paramètres de base",
  "mine.uploadCloud": "Sauvegarde cloud",
  "mine.changeVersion": "Vérifier les mises à jour",
  "mine.language": "Changer la langue",
  "mine.about": "À propos",
  "mine.feedback": "Retour d'information",
  "mine.logout": "Déconnexion",
  "mine.logoutAccount": "Supprimer le compte",

  "mine.logoutAccountTips": "Supprimer le compte nommé []",
  "mine.logoutAccountTips1": "Supprimer le compte lié []",
  "mine.logoutAccountCare": "Avis concernant la suppression:",
  "mine.logoutAccountCare1": "1. Le compte est sécurisé",
  "mine.logoutAccountCare1-1": "Le compte est normal, aucun risque de vol, violation, désactivation.",
  "mine.logoutAccountCare2": "2. Autorisations/liaisons révoquées",
  "mine.logoutAccountCare2-1": "Les autorisations auprès de tiers ont été révoquées.",
  "mine.logoutAccountCare3": "3. Compte irrécupérable après suppression",
  "mine.logoutAccountCare3-1": "Toutes les données seront définitivement supprimées.",
  "mine.confirmLogout": "Confirmer la suppression",
  "mine.logoutSuccess": "Compte supprimé avec succès!",

  "mine.feedbackIssues": "Signaler un problème",
  "mine.feedQuantity": "Quantité",
  "mine.feedAmount": "Max 9 images, 1MB/image",

  "mine.notice.fail": "Échec de la récupération des paramètres!",
  "mine.notice.saveSuccess": "Paramètres de notification sauvegardés!",
  "mine.notice.saveFail": "Échec de la sauvegarde!",
  "mine.notice.title": "Paramètres de notification",
  "mine.notice.batteryLow": "Batterie faible",
  "mine.notice.chargingFinish": "Charge terminée",
  "mine.notice.error": "Notification d'erreur",
  "mine.notice.update": "Notification de mise à jour",
  "mine.notice.monthly": "Statistiques mensuelles",
  "mine.notice.receiveType": "Méthode de réception",

  "mine.language.welcome": "Bienvenue sur SusprSafe",
  "mine.language.desc1": "Veuillez définir la langue selon votre région",
  "mine.language.desc2": "Modifiable à tout moment dans les paramètres",

  "mine.userInfo.avatar": "Photo de profil",
  "mine.userInfo.nickname": "Pseudonyme",
  "mine.userInfo.password": "Mot de passe",
  "mine.userInfo.changePassword": "Modifier le mot de passe",
  "mine.userInfo.setPassword": "Définir le mot de passe",
  "mine.userInfo.phoneNumber": "Numéro de téléphone",
  "mine.userInfo.bindPhone": "Lier un numéro",
  "mine.userInfo.bindEmail": "Lier un email",
  "mine.loginExpired": "Session expirée, veuillez vous reconnecter",
  "mine.userInfo.title": "Informations utilisateur",
  "mine.userInfo.bind": "Lier",
  "mine.userInfo.modify": "Modifier",
  "mine.userInfo.modifyNickname": "Modifier le pseudonyme",
  "mine.userInfo.userNickname": "Pseudonyme",
  "mine.userInfo.selectPic": "Sélectionner une image",
  "mine.userInfo.saveSuccess": "Sauvegardé avec succès",
  "mine.userInfo.uploadFail": "Échec du téléchargement",
  "mine.userInfo.avatarSaveSuccess": "Photo de profil sauvegardée",
  "mine.userInfo.nameTips1": "Le pseudonyme ne peut pas être vide",
  "mine.userInfo.nameTips2": "Veuillez saisir le pseudonyme",

  "common.pleaseSelect": "Veuillez sélectionner",
  "question.commonQuestions": "Questions fréquentes",
  "account.toggleLanguage": "Changer la langue",
  "account.localConnection": "Connexion locale",
  "account.selectLanguage": "Veuillez sélectionner la langue",
  "account.sendEmailToast": "Code envoyé à xxx, veuillez vérifier",
  "account.emailError": "Format d'email incorrect",
  "account.sendEmailFail": "Échec de l'envoi, veuillez réessayer",

  "common.submitting": "Soumission en cours, veuillez patienter...",

  "device.page.noData": "Aucune donnée, cette page nécessite l'application",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Mise à jour",
  "bmsFirmware.upgrading": "Mise à jour en cours...",
  "bmsFirmware.uploadingFile": "Téléchargement du fichier firmware...",
  "bmsFirmware.upgradingProgress": "Mise à jour du firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Mise à jour réussie",
  "bmsFirmware.upgradeSuccessSubtitle": "Mise à jour du firmware BMS terminée !",
  "bmsFirmware.upgradeFailed": "Mise à jour échouée",
  "bmsFirmware.upgradeFailedFormError": "Veuillez vérifier si le formulaire est correctement rempli",
  "bmsFirmware.upgradeFailedNetworkError": "Erreur réseau, veuillez réessayer",
  "bmsFirmware.invalidFileType": "Veuillez sélectionner un fichier firmware valide (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Veuillez d'abord sélectionner un fichier firmware",
  "bmsFirmware.statusUpgrading": "Mise à jour en cours",
  "bmsFirmware.statusCompleted": "Mise à jour terminée",
  "bmsFirmware.statusFailed": "Mise à jour échouée",
  "bmsFirmware.deviceUpgrading": "Mise à jour du package firmware en cours, la mise à jour prend 30 à 50 minutes, les données en temps réel de l'appareil ne peuvent pas être visualisées pendant cette période, veuillez patienter...",
  "bmsFirmware.upgradeStatusLabel": "Statut de la mise à jour",
  "bmsFirmware.upgradeProgressLabel": "Progrès de la mise à jour",
  "bmsFirmware.currentPackageLabel": "Numéro du paquet de données actuellement transmis",
  "bmsFirmware.totalPackagesLabel": "Nombre total de paquets de données",
  "bmsFirmware.upgradeFailedCheckDevice": "Veuillez vérifier l'état de l'appareil et réessayer la mise à jour",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Paramétrage réussi",
  "settingResult.defaultSubTitle": "Paramètres sauvegardés",
  "settingResult.confirmButton": "OK"
}